import { Tab as MuiTab } from '@mui/material';
import React from 'react';
import { CommonDataProps, SxProps } from '../../utils';

type NativeDivProps = React.ComponentPropsWithoutRef<'div'>;

export interface TabProps<T extends string | number> extends Omit<NativeDivProps, 'children'>, CommonDataProps {
  /**
   * The content that will be displayed in the tab
   */
  children: React.ReactNode;
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled?: boolean;
  /**
   * The link the tab will take you to
   */
  href?: string;
  /**
   * Component to use when rendering a Link. Often times will be our Link component for in app routing
   */
  LinkComponent?: React.ElementType;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps;
  /**
   * A unique identifier for the `Tab`. This prop is used to associate the tab with the currently selected `value` in the parent `TabGroup` component.
   * If not provided, the tab will default to using its index position.
   */
  value?: T;
}

export function Tab<T extends string | number>({ sx, children, ...props }: TabProps<T>) {
  return <MuiTab sx={sx} label={children} {...props} />;
}
